import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Text,
  Circle,
  Skeleton,
} from '@chakra-ui/react'
import {Modal} from 'antd'
import GlobalButton from '@components/GlobalButton/GlobalButton'
import {updateIsShowUpgradeModal} from '@redux/map/mapSlice'
import {useDispatch, useSelector} from 'react-redux'
import {useEffect, useState} from 'react'
import Lottie from 'lottie-react'
import checkCircleLottie from '@assets/lotties/check_circle.json'
import {ReactComponent as ArrowRight} from '@assets/svgs/roadmap/arrow_right.svg'
import appRequest from '@apis/app'
import Loading from '@components/Loading'
import {isLoggedIn, trackingEvent} from '@utils'
import {EVENT_NAME, LOCAL_STORAGE, PATH} from '@utils/Const'
import {useLocation, useNavigate} from 'react-router-dom'
import {CommonColors} from '@utils/CommonStyles'
import {ReactComponent as CloseIcon} from '@assets/svgs/close.svg'
import {DownloadIcon, CopyIcon} from '@chakra-ui/icons'
import axios from 'axios'

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_CRM_API,
})

const UpgradeModal = () => {
  const {isShowUpgradeModal, entryPointShowUpgradeModal} = useSelector(
    (state: any) => state.map,
  )
  const [data, setData] = useState<any>(null)
  const [orderData, setOrderData] = useState<any>(null)
  const [currentStep, setCurrentStep] = useState<number>(0)
  const [isLoading, setIsLoading] = useState(false)
  const [showCopyTooltip, setShowCopyTooltip] = useState(false)

  const {entry_point, task_id, is_new_register} = useLocation()?.state || {}

  const dispatch: any = useDispatch()
  const navigate = useNavigate()

  useEffect(() => {
    if (!is_new_register) return
    handleClickOrder()
  }, [is_new_register])

  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    try {
      const params = {
        product: 'BETA_LAUNCH',
      }
      const res = await appRequest.getUpgradePackage(params)
      setData(res?.data?.data)
    } catch (error) {}
  }

  const handleClickOrder = async () => {
    if (!isLoggedIn()) {
      navigate(PATH.LOGIN, {state: {entry_point, task_id}})
      return
    }

    trackingEvent(EVENT_NAME.SALE_PLACE_ORDER, {
      entry_point: entryPointShowUpgradeModal,
    })
    setCurrentStep(1)
    setIsLoading(true)
    try {
      const res1 = await axiosInstance.post('/api/public/orders/create', {
        phone: localStorage.getItem(LOCAL_STORAGE.USER_PHONE),
        product_code: data?.cms_package,
        email: localStorage.getItem(LOCAL_STORAGE.USER_EMAIL),
        name: localStorage.getItem(LOCAL_STORAGE.USER_NAME),
        order_type: 'Xác nhận', // Mặc định value Xác nhận
        order_note: 'IELTS: Đơn ấn nâng cấp ngay từ màn hình giá',
        channel_id: 37, // Mặc định là 37
        payment_type: 'TRANSFER', // Mặc định value Xác nhận
        promotion_code: data?.voucher,
      })
      const data1 = res1?.data?.data

      const res2 = await axiosInstance.post('/api/public/orders/get-qr', {
        bank_code: 'TCB',
        amount: data1?.amount, // lấy từ api tạo đơn
        bank_account: '19027838785669',
        transaction_desc: 'IE' + data1?.orderId, // mã hash trả từ api tạo đơn
      })
      const data2 = res2?.data?.data
      const data3 = {
        ...data1,
        ...data2,
      }
      setOrderData(data3)
    } catch (error) {}
    setIsLoading(false)
  }

  const handleClickTrial = () => {
    trackingEvent(EVENT_NAME.SALE_CONTINUE_TRIAL, {
      entry_point: entryPointShowUpgradeModal,
    })
    dispatch(updateIsShowUpgradeModal(false))
  }

  const handleSupportPayment = () => {
    window.open('https://m.me/61568988338315', '_blank')
  }

  const handleSubmitUpgrade = async () => {
    setCurrentStep(2)
  }

  const handleDownloadQRCode = async () => {
    if (orderData?.qr_code) {
      try {
        const response = await fetch(orderData.qr_code)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'qr-code.png'
        link.click()
        window.URL.revokeObjectURL(url)
      } catch (error) {
        console.error('Failed to download QR code:', error)
      }
    }
  }

  const handleCopyQRCode = () => {
    const bankInfo = `Ngân hàng: ${orderData?.company_bank_name}
Chủ tài khoản: ${orderData?.company_name}
Số tài khoản: ${orderData?.company_bank_account}
Số tiền: ${data?.price?.toLocaleString('vi-VN')} đ
Nội dung: ${orderData?.transaction_description}`

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard
        .writeText(bankInfo)
        .then(() => {
          setShowCopyTooltip(true)
          setTimeout(() => {
            setShowCopyTooltip(false)
          }, 3000)
        })
        .catch(handleFallbackCopy)
    } else {
      handleFallbackCopy()
    }

    function handleFallbackCopy() {
      const textarea = document.createElement('textarea')
      textarea.value = bankInfo
      textarea.style.position = 'fixed'
      textarea.style.left = '0'
      textarea.style.top = '0'
      textarea.style.opacity = '0'
      textarea.style.height = '1px'
      textarea.style.width = '1px'
      textarea.style.padding = '0'
      textarea.style.border = 'none'
      textarea.style.outline = 'none'
      textarea.style.boxShadow = 'none'
      textarea.style.background = 'transparent'
      textarea.style.visibility = 'hidden'

      document.body.appendChild(textarea)
      textarea.focus()
      textarea.select()
      try {
        setShowCopyTooltip(true)
        setTimeout(() => {
          setShowCopyTooltip(false)
        }, 3000)
        document.execCommand('copy')
        console.log('Fallback: Copying text successful')
      } catch (err) {
        console.error('Fallback: Could not copy text: ', err)
      }
      document.body.removeChild(textarea)
    }
  }

  const handleCancel = () => {
    trackingEvent(EVENT_NAME.SALE_CLOSE_SALE, {
      entry_point: entryPointShowUpgradeModal,
    })
    dispatch(updateIsShowUpgradeModal(false))
    setCurrentStep(0)
  }

  return (
    <Modal
      title={null}
      open={isShowUpgradeModal}
      centered={true}
      width={'960px'}
      closeIcon={null}
      footer={null}
      styles={{
        content: {
          padding: '0px',
          background: 'transparent',
          borderRadius: '36px',
          overflow: 'hidden',
        },
      }}
      onCancel={handleCancel}>
      <Box
        display={{base: 'block', md: 'none'}}
        position="absolute"
        right="16px"
        top="16px"
        zIndex="1"
        onClick={handleCancel}
        cursor="pointer">
        <Icon w={'20px'} h={'20px'} as={CloseIcon} />
      </Box>
      {currentStep === 0 && (
        <Box w={'100%'} position={'relative'}>
          <Image src={data?.image} alt="Banner Upgrade" />
          <Flex
            flexDirection={'column'}
            position={'absolute'}
            bottom={{base: '8px', md: '60px'}}
            w={'50%'}
            alignItems={'center'}>
            <GlobalButton
              color={'#072941'}
              p={{base: '16px 20px', md: '24px 30px'}}
              fontSize={{base: '14px', md: '16px'}}
              fontWeight={700}
              borderRadius={'16px'}
              bg={'linear-gradient(180deg, #FFF -8.04%, #A1D2FA 100%)'}
              _hover={{
                bg: 'linear-gradient(360deg, #FFF -8.04%, #A1D2FA 100%)',
              }}
              onClick={handleClickOrder}>
              Đặt mua ngay
            </GlobalButton>
            <Text
              display={{base: 'none', md: 'block'}}
              textDecoration="underline"
              color={'#D9D9D9'}
              pt={'8px'}
              cursor={'pointer'}
              onClick={handleClickTrial}>
              Tiếp tục dùng thử
            </Text>
          </Flex>
          <Text
            display={{base: 'none', md: 'block'}}
            position={'absolute'}
            bottom={{base: '3px', md: '24px'}}
            left={{base: '30px', md: '32px'}}
            color={'#D9D9D9'}
            fontSize={{base: '10px', md: '14px'}}>
            *Chúng mình sẽ liên hệ với bạn để xác nhận lại & bạn có thể huỷ ưu
            đãi này bất cứ lúc nào!
          </Text>
        </Box>
      )}
      {currentStep === 1 && (
        <Flex
          direction={{base: 'column', md: 'row'}}
          justify="space-between"
          p={{base: '16px', md: '32px'}}
          bg="white"
          borderRadius={'16px'}
          boxShadow="md"
          gap={{base: '16px', md: '24px'}}>
          <Flex w={{base: '100%', md: '65%'}} flexDirection={'column'}>
            <Text
              fontSize={{base: '24px', md: '30px'}}
              fontWeight="bold"
              mb="16px"
              color={CommonColors.primary}>
              IELTS Coach Premium
            </Text>
            <Text fontSize="18px" mb="24px" fontWeight={600} color={'gray.600'}>
              Thanh toán
            </Text>
            <Box mb="24px">
              <Flex mb="16px">
                <Circle
                  size="20px"
                  bg={CommonColors.primary}
                  color="white"
                  mr="12px">
                  1
                </Circle>
                <Text fontSize="14px">
                  Quét mã QR bằng ứng dụng ngân hàng để chuyển khoản
                </Text>
              </Flex>

              <Flex mb="16px">
                <Circle
                  size="20px"
                  bg={CommonColors.primary}
                  color="white"
                  mr="12px">
                  2
                </Circle>
                <Text fontSize="14px">
                  Điền nội dung chuyển khoản là{' '}
                  <Text as="span" color={CommonColors.primary} fontWeight="600">
                    {`IE${orderData?.orderId}`}
                  </Text>
                </Text>
              </Flex>

              <Flex>
                <Circle
                  size="20px"
                  bg={CommonColors.primary}
                  color="white"
                  mr="12px">
                  3
                </Circle>
                <Text fontSize="14px">
                  Sau khi chuyển lưu lại ảnh chuyển khoản, để ý điện thoại bọn
                  mình sẽ liên hệ để mở khoá
                </Text>
              </Flex>
            </Box>
            <Flex
              mt="auto"
              gap={{base: '8px', md: '12px'}}
              justifyContent={'center'}
              flexDirection={{base: 'column', sm: 'row'}}>
              <Button
                w={{base: '100%', sm: '200px'}}
                bg={'#d1e9ff'}
                fontSize={'14px'}
                color={CommonColors.primary}
                onClick={handleSupportPayment}>
                Hỗ trợ thanh toán
              </Button>
              <GlobalButton
                fontSize={'14px'}
                w={{base: '100%', sm: '200px'}}
                onClick={handleSubmitUpgrade}>
                Chuyển khoản thành công
              </GlobalButton>
            </Flex>
            <Text
              cursor={'pointer'}
              mt="8px"
              color="gray.700"
              textDecoration={'underline'}
              textAlign={'center'}
              onClick={() => {
                handleClickTrial()
                setCurrentStep(0)
              }}>
              Tiếp tục dùng thử
            </Text>
          </Flex>
          <Box w={{base: '100%', md: '35%'}} textAlign="center">
            <Text
              fontSize={{base: '18px', md: '20px'}}
              color={CommonColors.primary}>
              Chuyển khoản
            </Text>
            <Text
              fontSize={{base: '24px', md: '30px'}}
              fontWeight="bold"
              color={CommonColors.primary}>
              {data?.price?.toLocaleString('vi-VN')}{' '}
              <Text
                as="span"
                fontSize={{base: '14px', md: '16px'}}
                color={'gray.600'}>
                VND / {data?.expired_time || ''}
              </Text>
            </Text>
            <Text fontSize="16px" mb="12px" color={'gray.600'}>
              Nội dung chuyển:
            </Text>
            <Text
              fontSize="24px"
              fontWeight="bold"
              mb="16px"
              color={CommonColors.primary}>
              {`IE${orderData?.orderId}`}
            </Text>
            <Box
              w={{base: '180px', md: '200px'}}
              h={{base: '180px', md: '200px'}}
              mx={'auto'}
              mb="8px">
              {orderData?.qr_link ? (
                <Image
                  w={'100%'}
                  h={'100%'}
                  alt="QR Code"
                  loading="lazy"
                  src={orderData?.qr_link}
                />
              ) : (
                <Skeleton w={'100%'} h={'100%'}></Skeleton>
              )}
            </Box>
            <Flex justifyContent={'center'} gap={'8px'} mb="16px">
              <Button
                w="40%"
                h="35px"
                mr="8px"
                color={CommonColors.primary}
                leftIcon={<Icon as={DownloadIcon} w="20px" h="20px" />}
                onClick={handleDownloadQRCode}>
                Tải về
              </Button>
              <Button
                w="40%"
                h="35px"
                color={CommonColors.primary}
                leftIcon={<Icon as={CopyIcon} w="20px" h="20px" />}
                onClick={handleCopyQRCode}
                position="relative"
                _after={{
                  content: '"Đã sao chép"',
                  position: 'absolute',
                  top: '-30px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  backgroundColor: 'gray.700',
                  color: 'white',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  fontSize: '12px',
                  opacity: showCopyTooltip ? 1 : 0,
                  transition: 'opacity 0.2s',
                  whiteSpace: 'nowrap',
                }}>
                Sao chép
              </Button>
            </Flex>
            <Text fontSize="14px" fontWeight="bold" color={'gray.600'}>
              CONG TY CO PHAN GIAO DUC TIEN BO
            </Text>
            <Text fontSize="14px" fontWeight="bold" color={'gray.600'}>
              {`TECHCOMBANK - 19027838785669`}
            </Text>
          </Box>
        </Flex>
      )}
      {currentStep === 2 && (
        <Flex
          flexDirection={'column'}
          alignItems={'center'}
          w={'100%'}
          p={'32px'}
          bg={'white'}
          borderRadius={'16px'}>
          <Box w={'250px'}>
            <Lottie animationData={checkCircleLottie} />
          </Box>
          <Text fontSize={'30px'} fontWeight={600} textAlign={'center'}>
            Cảm ơn bạn vì đã tin tưởng IETLS Coach
          </Text>
          <Text
            pt={'16px'}
            fontSize={'16px'}
            textAlign={'center'}
            maxW={'500px'}>
            Tài khoản của bạn đang trong giai đoạn 'chờ nâng cấp' và sẽ được mở
            khóa trong 5 phút nữa! Nếu sau 5 phút mà vẫn 'im lìm', đừng ngại
            liên hệ Fanpage để chúng mình 'hô biến' ngay cho bạn nhé! 😎
          </Text>
          <Flex justifyContent={'center'} mt={'40px'} mb={'24px'}>
            <GlobalButton
              px={'30px'}
              borderRadius={'16px'}
              onClick={handleCancel}>
              Học tiếp{' '}
              <Icon
                as={ArrowRight}
                ml={2}
                w={'20px'}
                h={'20px'}
                sx={{
                  path: {
                    stroke: 'white',
                  },
                }}
              />
            </GlobalButton>
          </Flex>
        </Flex>
      )}
      {isLoading && <Loading />}
    </Modal>
  )
}

export default UpgradeModal
